import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import {useTranslation} from '@malt/vue3-use';
    import ApplicationStatus from '@/profile-creation-wizard/components/waiting-room/ApplicationStatus.vue';
    import {useStore} from 'vuex';
    import actions from '@/profile-creation-wizard/store/completion/actions';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationAccepted',
  setup(__props) {

    const {msg} = useTranslation();
    const store = useStore();

    const statusData = {
        title: msg('profile.creation.wizard.strategy.waiting.room.application.accepted.title'),
        ctaLabel: msg('profile.creation.wizard.strategy.waiting.room.application.accepted.cta.label'),
        imageUrl: 'https://dam.malt.com/signup/waiting-room/welcome.svg?vh=e7ae19',
    };
    const content = [
        msg('profile.creation.wizard.strategy.waiting.room.application.accepted.line1'),
        msg('profile.creation.wizard.strategy.waiting.room.application.accepted.line2'),
        msg('profile.creation.wizard.strategy.waiting.room.application.accepted.line3'),
    ];
    async function handleConfirm() {
        await store.dispatch(actions.confirmApplicationStatus);
    }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ApplicationStatus, _mergeProps(statusData, { "onWaitingRoomCta:clicked": handleConfirm }), {
    content: _withCtx(() => [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(content, (line, index) => {
        return _createElementVNode("p", {
          key: `line-${index}`,
          innerHTML: line
        }, null, 8, _hoisted_1)
      }), 64))
    ]),
    _: 1
  }, 16))
}
}

})